import { IChatV2Schema } from '@cian/chats-api/lib/browser-entry';

import { EChatListActionTypes, IChatListRequest } from './types';
import { TChatDataInListSchema } from '../../types/chatList';
import { actionGenerator } from '../../utils/redux/actionGenerator';

/**
 * Установить начальное состояние чатов
 */
export const setChatListInitial = actionGenerator<EChatListActionTypes.SetInitial, void>(
  EChatListActionTypes.SetInitial,
);

/**
 * Запрос за списком чатов
 */
export const setChatListPending = actionGenerator<EChatListActionTypes.SetPending, IChatListRequest>(
  EChatListActionTypes.SetPending,
);

/**
 * Успешное получение первой страницы списка
 */
export const setChatListLoadPageSucceed = actionGenerator<EChatListActionTypes.SetLoadPageSucceed, void>(
  EChatListActionTypes.SetLoadPageSucceed,
);

/**
 * Установить/убрать состояние загрузки списка чатов
 */
export const toggleChatListPending = actionGenerator<EChatListActionTypes.TogglePending, boolean>(
  EChatListActionTypes.TogglePending,
);

/**
 * Установить список чатов
 */
export const setChatListSucceed = actionGenerator<EChatListActionTypes.SetSucceed, TChatDataInListSchema[]>(
  EChatListActionTypes.SetSucceed,
);

/**
 * Установить целый список чатов
 */
export const setFullChatListSucceed = actionGenerator<EChatListActionTypes.SetFullSucceed, TChatDataInListSchema[]>(
  EChatListActionTypes.SetFullSucceed,
);

/**
 * Установить ошибку запроса списка чатов
 */
export const setChatListFailed = actionGenerator<EChatListActionTypes.SetFailed, void>(EChatListActionTypes.SetFailed);

/**
 * Обновление чата по веб-сокету
 */
export const updatedFromServer = actionGenerator<EChatListActionTypes.UpdatedFromServer, IChatV2Schema>(
  EChatListActionTypes.UpdatedFromServer,
);

/**
 * Установить состояние изменения списка
 */
export const toggleChangeListActive = actionGenerator<EChatListActionTypes.ToggleChangeListActive>(
  EChatListActionTypes.ToggleChangeListActive,
);

/**
 * Добавить чат в список выбранных чатов
 */
export const addChatToSelected = actionGenerator<EChatListActionTypes.AddChatToSelected, string>(
  EChatListActionTypes.AddChatToSelected,
);

/**
 * Удалить чат из списка выбранных чатов
 */
export const removeChatFromSelected = actionGenerator<EChatListActionTypes.RemoveChatFromSelected, string>(
  EChatListActionTypes.RemoveChatFromSelected,
);

/**
 * Добавить все чаты в список выбранных чатов
 */
export const selectAllChats = actionGenerator<EChatListActionTypes.SelectAllChats>(EChatListActionTypes.SelectAllChats);

/**
 * Удалить все чаты из списка выбранных чатов
 */
export const deselectAllChats = actionGenerator<EChatListActionTypes.DeselectAllChats>(
  EChatListActionTypes.DeselectAllChats,
);
